<script setup lang="ts" generic="T">
    import BaseIcon from '@/components/BaseIcon.vue';
    import type { ISelectOption } from '@/typescript/interfaces/ISelectOption';

    const model = defineModel<T>();

    withDefaults(
        defineProps<{
            label: string;
            name: string;
            options: ISelectOption<T>[];
            placeholder?: string;
            disabled?: boolean;
            rounded?: boolean;
            showLabel?: boolean;
        }>(),
        {
            placeholder: '',
            disabled: false,
            rounded: false,
            showLabel: true,
        },
    );
</script>

<template>
    <div class="relative">
        <label
            :for="name"
            :class="[!showLabel && 'sr-only']"
            >{{ label }}</label
        >
        <select
            :id="name"
            v-model="model"
            :name
            :class="[
                'h-8 w-full cursor-pointer appearance-none truncate border border-border-primary bg-white px-1.5 text-sm font-normal text-text transition-colors duration-300 hover:bg-bg-secondary',
                rounded && 'rounded-full',
                !rounded && 'rounded-none',
                disabled && 'cursor-not-allowed opacity-70',
            ]"
            data-test="select"
            :disabled
        >
            <option
                :value="undefined"
                class="disabled hidden"
                :selected="model === undefined"
            >
                {{ placeholder }}
            </option>
            <option
                v-for="option in options"
                :key="option.key"
                data-test="select-option"
                class="w-full appearance-none truncate bg-white text-primary"
                :value="option.value"
                :selected="model === option.value"
            >
                {{ option.label }}
            </option>
        </select>
        <BaseIcon
            name="ChevronDownIcon"
            class="pointer-events-none absolute right-2 top-2 text-text"
        />
    </div>
</template>
